import React from 'react';
import CompatioApi from '../../api/CompatioApiXrsV3';
import EcommerceApi from '../../api/EcommerceApi';
import ReactResizeDetector from 'react-resize-detector';
import { FormattedMessage } from 'react-intl';
import _, { get as _get } from 'lodash-es';
import ProductList from '../product-list/ProductListXrs';
import CompatibleProduct from './CompatibleProduct';
import CompatioAnalytics from '../../api/CompatioAnalytics';
import PopupXRS from '../popups/PopupXRS';
import ProductSort from '../utils/ProductSortXrs';
import compatioImg from '../../styles/images/build-it-out.png';
import PopupBundler from '../popups/PopupBundler';

class CompatibleProducts extends React.Component {
  /**
   * Track whether component is mounted
   *
   * @type {boolean}
   * @private
   */
  _isMounted = false;

  anchor = document.getElementById('xrsanchor');

  static defaultProps = {
    /**
     * The merchant product ID. This value should always be passed in during the initialization of this component
     */
    productSku: null,
    /**
     * The product name of the current product being viewed.
     */
    productName: null,
    /**
     * Products to show user until "Show More" button hides the rest of the products
     */
    productsPerPage: 10,
    /**
     * Breakpoint to switch between tabs/accordion behavior
     */
    desktopModeWidth: 768,
    /**
     * For variable products, if user hasn't selected a specific product, a random child SKU will be passed to this
     * component so that a list of categories can be retrieved from the Compatio API. If a random SKU is passed, this
     * prop should be set to "true"
     */
    isProductSkuRandom: false,
    /**
     * If enabled, when page first loads, all product data will be retrieved from ecommerce API (for the
     * first "productsPerPage" products within each category). This will result in compatible products showing
     * immediately when a category is clicked. However it will result in more bandwidth usage for users and a
     * higher load on the ecommerce server API.
     */
    isPreloadEcommerceDataEnabled: true,
  };

  constructor(props) {
    super(props);
    const merchantProductSku = props.productSku;
    const merchantProductName = props.productName;
    if (
      _get(
        window,
        'compatioConfig.compatibleProducts.callbacks.beforeConstruct'
      )
    ) {
      window.compatioConfig.compatibleProducts.callbacks.beforeConstruct();
    }

    window.compatioConfig.compatibleProducts.methods =
      window.compatioConfig.compatibleProducts.methods || {};

    // Register function in global namespace
    window.compatioConfig.compatibleProducts.methods.handleChangeProductSku = this.handleChangeProductSku.bind(
      this
    );
    this.state = {
      compatioCategories: [],
      compatioCategoriesUpdated: [],
      activeCompatioCategories: {},
      defaultSorting: 'compatioscore_descending',
      merchantProductSku: merchantProductSku,
      merchantProductName: merchantProductName,
      isProductSkuRandom: this.props.isProductSkuRandom,
      isDesktopMode: this.isDesktopMode(),
      isBundlerOpen: false,
      IsPlatformShopify:
        typeof _get(window, 'compatioConfig.shopify') === 'object',
      errorMessage: false,
      maximumProducts: _get(window, 'compatioConfig.shopify.maximumProducts')
        ? _get(window, 'compatioConfig.shopify.maximumProducts')
        : _get(window, 'compatioConfig.magento.maximumProducts'),
      maximumCategories: _get(
        window,
        'compatioConfig.shopify.maximumCategories'
      )
        ? _get(window, 'compatioConfig.shopify.maximumCategories')
        : _get(window, 'compatioConfig.magento.maximumCategories'),
      firstTimeLoad: true,
    };

    this.setMerchantProductSku(merchantProductSku);
    this.onResize = this.onResize.bind(this);
    this.handleChangeSortOrder = this.handleChangeSortOrder.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  toggleBundler = () => {
    const { isBundlerOpen } = this.state;
    this.setState({
      isBundlerOpen: !isBundlerOpen,
    });
  };

  /**
   * Update sort order
   *
   * @param sortOrder
   */
  handleChangeSortOrder(sortOrder) {
    this.setState({
      defaultSorting: sortOrder,
    });

    // this.props.changeSorting(sortOrder);
  }

  /**
   * Allow a third-party script to update the current merchant product ID
   *
   * Ecommerce platform will call this when a user changes the child SKU on a Variable Product page
   *
   * @param productSku
   * @param isProductSkuRandom
   */
  handleChangeProductSku(productSku, isProductSkuRandom) {
    // If isProductSkuRandom is undefined, coerce to false
    isProductSkuRandom = !!isProductSkuRandom;

    // Don't update anything if nothing has changed
    if (
      productSku === this.state.merchantProductSku &&
      isProductSkuRandom === this.state.isProductSkuRandom
    ) {
      // return;
    }
    this.setState({ isProductSkuRandom: isProductSkuRandom });
    this.setMerchantProductSku(productSku);
  }

  /**
   * Update this component to show compatibility information for a different product ID
   *
   * @param merchantProductSku
   * @returns {Promise<void>}
   */
  async setMerchantProductSku(merchantProductSku) {
    try {
      const compatioCategoryData = await CompatioApi.getCategoryDataByProductSku(
        merchantProductSku,
        this.state.maximumCategories,
        this.state.maximumProducts
      );
      // console.log(compatioCategoryData, 'compatioCategoryData');

      if (compatioCategoryData.length > 0) {
        this.anchor.style.display = 'block';
        if (this._isMounted) {
          this.setState({
            merchantProductSku: merchantProductSku,
            compatioCategories: compatioCategoryData,
            errorMessage: false,
          });
        }
        const eCommercePlatform = this.state.IsPlatformShopify ? 'shopify' : '';

        if (!this.props.isPreloadEcommerceDataEnabled) {
          return;
        }

        const allMerchantProductSkus = CompatioApi.extractAllProductSkus(
          compatioCategoryData
        );
        try {
          // Preload ecommerce data; don't do anything with the returned data
          const getUpdateddata = await EcommerceApi.loadProductDataFromEcommerceXrs(
            allMerchantProductSkus,
            eCommercePlatform,
            compatioCategoryData
          );
          if (this._isMounted) {
            const compatioCategoryDataAfterFilter = compatioCategoryData.filter(
              e => {
                const getupdateds = e.products.filter(ey => {
                  const getupdated = getUpdateddata.data.filter(eys => {
                    if (
                      (ey.merchantProductId === eys.merchantProductSku) ==
                      true
                    ) {
                      return eys;
                    }
                  });
                  if (getupdated.length != 0) return getupdated;
                });
                if (getupdateds.length != 0) return e;
              }
            );
            // Optionally filter products within each category
            const finalResult = compatioCategoryDataAfterFilter.map(
              category => ({
                ...category,
                products: category.products.filter(product =>
                  getUpdateddata.data.some(
                    updatedProduct =>
                      product.merchantProductId ===
                      updatedProduct.merchantProductSku
                  )
                ),
              })
            );
            this.setState({
              compatioCategoriesUpdated: finalResult,
            });
            //this below 2 lines for help to stop extra xrs api call when bundle loading...step two
            window.compatioConfig.bundlerData = finalResult;
            window.dispatchEvent(new Event('bundlerDataReady'));

            const div = document.querySelector('.xrs-container');
            const width = div.offsetWidth;
            let prodcutCountNumber =
              finalResult[0].products.length <= 2
                ? finalResult[0].products.length
                : 2;
            if (width >= 982) {
              prodcutCountNumber =
                finalResult[0].products.length <= 6
                  ? finalResult[0].products.length
                  : 6;
            } else if (width >= 848) {
              prodcutCountNumber =
                finalResult[0].products.length <= 4
                  ? finalResult[0].products.length
                  : 4; // This will be applied if width is 750 or greater
            } else if (width >= 547) {
              prodcutCountNumber =
                finalResult[0].products.length <= 3
                  ? finalResult[0].products.length
                  : 3; // This will be applied if width is between 450 and 749
            }
            // console.log(compatioCategoryData[0].products.length,'dfsdfs')
            CompatioAnalytics.track(
              CompatioAnalytics.events.RecShown,
              {
                baseFinalProductID: this.state.merchantProductSku,
                baseParentProductID: this.props.productId,
                baseFinalProductName: this.state.merchantProductName,
                productsShownCount: prodcutCountNumber,
              },
              'XRS',
              'V3'
            );

            this.setCompatioCategoryId(
              compatioCategoryDataAfterFilter[0].categoryId
            );
          }
          // console.log(allMerchantProductSkus,'allMerchantProductSkus')
        } catch (e) {
          // Don't do anything with errors thrown by loadProductDataFromEcommerce (such as an API timeout), since
          // subsequent calls to this method could be successful (since it will be a smaller set of data requested)
          console.error(e);
        }
      } else {
        this.anchor.style.display = 'none';
        this.setState({
          errorMessage: true,
        });
      }
    } catch (e) {
      this.setState({
        errorMessage: true,
      });
      //console.error(e);
    }
  }

  /**
   * Determine if category is currently active
   *
   * @param compatioCategoryData
   * @param categoryId
   * @returns {*}
   */
  isCategoryIdInActiveCategories(compatioCategoryData, categoryId) {
    return compatioCategoryData.find(categoryObject => {
      return categoryObject.categoryId === categoryId;
    });
  }

  /**
   * Toggle mode, if resize has resulted in mode changing
   */
  onResize() {
    const isDesktopMode = this.isDesktopMode();
    // Only update if the mode has changed
    if (this.state.isDesktopMode !== isDesktopMode) {
      this.setState({ isDesktopMode: isDesktopMode });

      // If changing from mobile > desktop, close all panels so that multiple tabs aren't selected at once
      if (isDesktopMode) {
        this.setState({
          // activeCompatioCategories: {},
          activeCompatioCategories: {
            [this.state.compatioCategories[0].categoryId]: true,
          },
        });
      }
    }
  }

  // TODO: Implement accessibility for accordion/tab view. Reference: https://getbootstrap.com/docs/4.1/components/collapse/#accessibility
  /**
   * Toggle the visibility of "compatible products" for a given category
   *
   * @param compatioCategoryId
   */
  setCompatioCategoryId(categoryId, category) {
    let activeCategories = {};
    // Allow multiple sections to be open at a time on mobile
    if (!this.isDesktopMode()) {
      activeCategories = { ...this.state.activeCompatioCategories };
    }

    let analyticsAction;
    if (this.state.activeCompatioCategories.hasOwnProperty(categoryId)) {
      // If category section is expanded, collapse it
      delete activeCategories[categoryId];
      analyticsAction = 'close';
    } else {
      // Show category section
      activeCategories[categoryId] = true;
      analyticsAction = 'open';
    }
    if (!this.state.firstTimeLoad) {
      const mergedDataForCount = Object.values(
        category.products.reduce((acc, item) => {
          const parentId = item.merchantParentProductId;
          if (!acc[parentId]) {
            acc[parentId] = {
              merchantParentProductId: parentId,
              compatioScore: item.compatioScore,
              merchantProductIds: [item.merchantProductId],
            };
          } else {
            acc[parentId].merchantProductIds.push(item.merchantProductId);
            if (
              Number(item.compatioScore) > Number(acc[parentId].compatioScore)
            ) {
              acc[parentId].compatioScore = item.compatioScore;
            }
          }
          return acc;
        }, {})
      );

      const div = document.querySelector('.xrs-container');
      const width = div.offsetWidth;
      let prodcutCountNumber =
        mergedDataForCount.length <= 2 ? mergedDataForCount.length : 2;
      if (width >= 982) {
        prodcutCountNumber =
          mergedDataForCount.length <= 5 ? mergedDataForCount.length : 5;
      } else if (width >= 848) {
        prodcutCountNumber =
          mergedDataForCount.length <= 4 ? mergedDataForCount.length : 4; // This will be applied if width is 750 or greater
      } else if (width >= 547) {
        prodcutCountNumber =
          mergedDataForCount.length <= 3 ? mergedDataForCount.length : 3; // This will be applied if width is between 450 and 749
      }
      CompatioAnalytics.track(
        CompatioAnalytics.events.xrsCategoryClick,
        {
          baseFinalProductID: this.state.merchantProductSku,
          baseParentProductID: this.props.productId,
          baseFinalProductName: this.state.merchantProductName,
          categoryID: categoryId,
          categoryPosition: this.getCategoryPosition(
            this.state.compatioCategories,
            categoryId
          ),
          categoryName: this.getCategoryName(
            this.state.compatioCategories,
            categoryId
          ),
          clickAction: CompatioAnalytics.clicks.xrsOpenCategory,
          productsShownCount: prodcutCountNumber,
        },
        'XRS',
        'V3'
      );
    }

    this.setState({
      activeCompatioCategories: activeCategories,
      firstTimeLoad: false,
    });
  }

  /**
   * Get position of current category vs all categories. Used for analytics purposes.
   *
   * @param allCategories
   * @param currentCategoryId
   * @returns {number}
   */
  getCategoryPosition(allCategories, currentCategoryId) {
    let position = allCategories.findIndex(
      categoryData => categoryData.categoryId === currentCategoryId
    );
    return ++position;
  }

  /**
   * Get name of current category. Used for analytics purposes.
   *
   * @param allCategories
   * @param currentCategoryId
   * @returns {name}
   */
  getCategoryName(allCategories, currentCategoryId) {
    let CurrentCategoryName = allCategories.find(
      categoryData => categoryData.categoryId === currentCategoryId
    ).categoryName;
    return CurrentCategoryName;
  }

  /**
   * Get whether viewport is currently desktop mode
   *
   * @returns {boolean}
   */
  isDesktopMode() {
    return window.innerWidth > this.props.desktopModeWidth;
  }

  renderCategoriesAndProducts() {
    // const compatioCategories = this.state.compatioCategories;
    const compatioCategories = this.state.compatioCategoriesUpdated;
    const button = document.querySelector('.btn.btn--full.add-to-cart');

    // Set the button's display property to 'block'
    if (button != null) {
      button.style.display = 'block';
    }
    // const sortedCategories = compatioCategories.sort((a, b) => {
    //   return a.relevanceRank - b.relevanceRank;
    // });
    const categories = [];
    const productLists = [];
    let iCount = 0;
    let exitLoop = false;
    //sortedCategories.forEach((category, index) => {
    compatioCategories.forEach((category, index) => {
      iCount++;

      // console.log(iCount,iCount==5,'iCount')
      if (iCount === 6) {
        exitLoop = true;
      }

      if (exitLoop) {
        return; // This will exit the current iteration but not the forEach loop
      }
      let categoryIsActive = this.state.activeCompatioCategories.hasOwnProperty(
        category.categoryId
      );
      categories.push(
        <CompatibleProduct
          key={category.categoryId}
          isActive={categoryIsActive}
          onClick={() =>
            this.setCompatioCategoryId(category.categoryId, category)
          }
          {...category}
        />
      );

      // Don't add product list if the associated category is not selected
      if (!categoryIsActive) {
        return;
      }
      let productList;
      if (this.state.isProductSkuRandom) {
        // For Variable Products, if specific child SKU has not been selected, show placeholder message
        productList = (
          <h3
            key={`selectProductOption_${category.categoryId}_${this.state.merchantProductSku}`}
          >
            <FormattedMessage
              id="CompatibleProducts.variable_product_select_options"
              defaultMessage="Please select product options above to see compatible products"
            />
          </h3>
        );
      } else {
        productList = (
          <ProductList
            key={`productList_${category.categoryId}_${this.state.merchantProductSku}`}
            categoryId={category.categoryId}
            categoryPosition={index}
            categoryName={category.categoryName}
            compatioSorting={_get(category, 'sorting', false)}
            defaultSorting={this.state.defaultSorting}
            merchantProductSku={this.state.merchantProductSku}
            merchantProductId={this.props.productId}
            productName={this.props.productName}
            productsPerPage={this.props.productsPerPage}
            maximumCategories={this.state.maximumCategories}
            maximumProducts={this.state.maximumProducts}
          />
        );
      }
      // console.log(compatioCategories,productList)

      if (!this.isDesktopMode()) {
        // On mobile, product lists need to be immediately adjacent to their corresponding category links
        categories.push(productList);
      } else {
        productLists.push(productList);
      }
    });

    return [categories, productLists];
  }

  render() {
    // TODO: Figure out why render is called twice when clicking a category thumbnail
    // console.trace('CompatibleProducts.render. Current products: ', this.state.currentProducts);

    const compatioCategories = _.cloneDeep(this.state.compatioCategories);
    const merchantProductName = this.state.merchantProductName;
    if (this.state.errorMessage !== false) return null;
    if (!compatioCategories.length) {
      //CompatioApi.reset();
      return null;
    }

    const [categories, productLists] = this.renderCategoriesAndProducts();

    return (
      <>
        <div id="xrs-anchor"></div>
        <div className="xrs-container">
          <div className="xrs-compatible-products">
            <div className="xrs-heading">
              <h3>
                <img src={compatioImg} className="compatio-img"></img>
                <FormattedMessage
                  id="CompatibleProducts.heading"
                  defaultMessage="Compatible Products."
                />
              </h3>
              <div className="xrs-logo">
                <a href="https://www.compat.io/feedback" target="_blank">
                  <img
                    src="https://d1qrqn8mibon78.cloudfront.net/powered-by-compatio.png"
                    alt="Compatio"
                    style={{ textAlign: 'right' }}
                  />
                </a>
              </div>
            </div>
            <div className="xrs-description">
              <div className="xrs-text-main">
                <span id="xrs-text"></span>
                <PopupXRS />
              </div>
              <div className="xrs-sort">
                <ProductSort
                  handleChangeSortOrder={this.handleChangeSortOrder}
                  currentSortOrder={this.state.defaultCategorySorting}
                  sorting={this.state.sorting}
                />
              </div>
            </div>
            <div className="xrs-categories">{categories}</div>
            {productLists}

            <ReactResizeDetector
              handleWidth
              refreshMode="debounce"
              refreshRate={250}
              onResize={this.onResize}
            />
          </div>
        </div>
        <button
          id="xrs-bundle"
          className="button"
          onClick={this.toggleBundler}
          style={{ visibility: 'hidden' }}
        >
          Open Bundler
        </button>

        {this.state.isBundlerOpen ? (
          <PopupBundler
            isOpen={this.state.isBundlerOpen}
            bundlerType="bundler"
            toggleBundler={this.toggleBundler}
            productData={[...compatioCategories]}
            parentProduct={this.props}
            parentProductSku={this.state.merchantProductSku}
            defaultBacking={
              this.props.backingData &&
              this.props.backingData[0] &&
              this.props.backingData[0].variantId
            }
          />
        ) : null}
      </>
    );
  }
}

export default CompatibleProducts;
